export class SetCookieConsent {
  static readonly type = '[User] SetCookieConsent';

  constructor(public cookieConsent: string) { }
}
